import useBasicDevices from "./useBasicDevices";

export default function useVirtualDevices() {
  const { devices, loading, error } = useBasicDevices();

  const virtualDevices = devices.filter(d => d.entityType?.id === 3);

  return {
    devices: virtualDevices,
    loading,
    error
  };
}